import { FormattedMessage } from 'react-intl';

import { isEmpty } from '~utils/object';
import { UsergroupsListItem } from './UsergroupsListItem';
import styles from './UsergroupsList.module.css';

export type UsergroupsListProps = {
  usergroups: UsergroupShape[];
};

export const UsergroupsList = ({ usergroups }: UsergroupsListProps) => (
  <div className={styles.list}>
    {isEmpty(usergroups) ? (
      <div className={styles.listItem}>
        <div className={styles.cellNotification}>
          <em>
            <FormattedMessage id="msgNoUsergroups" defaultMessage="msgNoUsergroups" />
          </em>
        </div>
      </div>
    ) : (
      <div className={styles.list}>
        {usergroups.map(usergroup => (
          <UsergroupsListItem key={usergroup.uuid} usergroup={usergroup} />
        ))}
      </div>
    )}
  </div>
);
